import {connect} from 'react-redux';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  LEVEL,
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
  TYPE,
} from '/enum/apiFields.enum';
import {
  REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
  REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
  REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
  REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
  REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_ORDER,
  REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
  REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
  REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
} from '/enum/records.enum';
import {fetch} from '/redux/action/report.action';
import {
  isAlertsLoading,
  isClientJourneyLoading,
} from '/redux/selector/client.selector';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {
  hasClientsToContactReport,
  isEmptyClientsToContactReport,
  reportIsLoadingStateValue,
  reportMeta,
} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {PeopleToContact} from './PeopleToContact';

export default connect(
  createStructuredSelector({
    // Checks for the presence of data after loading
    isEmptyNoOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
    })(isEmptyClientsToContactReport),
    isEmptyPremierCancellations: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
    })(isEmptyClientsToContactReport),
    isEmptyRecentlyInactive: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
    })(isEmptyClientsToContactReport),
    isEmptyExpiringWellnessCredits: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
    })(isEmptyClientsToContactReport),
    isEmptyExpiringRewards: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
    })(isEmptyClientsToContactReport),
    isEmptyNextTask: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
    })(isEmptyClientsToContactReport),
    isEmptyNoActiveOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
    })(isEmptyClientsToContactReport),
    isEmptyNoRXOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    })(isEmptyClientsToContactReport),
    isEmptyNewCandidate: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
    })(isEmptyClientsToContactReport),
    // Checks for the presence of initial data before loading
    hasNoOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
    })(hasClientsToContactReport),
    hasExpiringRewards: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
    })(hasClientsToContactReport),
    hasRecentlyInactive: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
    })(hasClientsToContactReport),
    hasPremierCancellations: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
    })(hasClientsToContactReport),
    hasExpiringWellnessCredits: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
    })(hasClientsToContactReport),
    hasNextTask: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
    })(hasClientsToContactReport),
    hasNoActiveOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
    })(hasClientsToContactReport),
    hasNoRXOrder: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    })(hasClientsToContactReport),
    hasNewCandidate: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
    })(hasClientsToContactReport),

    noOrderIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
    })(reportIsLoadingStateValue),
    expiringRewardsIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
    })(reportIsLoadingStateValue),
    recentlyInactiveIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
    })(reportIsLoadingStateValue),
    premierCancellationsIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
    })(reportIsLoadingStateValue),
    expiringWellnessCreditsIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
    })(reportIsLoadingStateValue),
    nextTaskIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
    })(reportIsLoadingStateValue),
    noActiveOrderIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
    })(reportIsLoadingStateValue),
    noRXOrderIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    })(reportIsLoadingStateValue),
    newCandidateIsLoading: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
    })(reportIsLoadingStateValue),

    noOrderMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ORDER,
    })(reportMeta),
    expiringRewardsMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_REWARDS,
    })(reportMeta),
    recentlyInactiveMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_RECENTLY_INACTIVE,
    })(reportMeta),
    premierCancellationsMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_PREMIER_CANCELATION,
    })(reportMeta),
    expiringWellnessCreditsMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_EXPIRING_WELLNESS_CREDITS,
    })(reportMeta),
    nextTaskMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEXT_TASK,
    })(reportMeta),
    noActiveOrderMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_ACTIVE_ORDER,
    })(reportMeta),
    noRXOrderMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NO_RX_ORDER,
    })(reportMeta),
    newCandidateMeta: withProps({
      reportName: REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE,
    })(reportMeta),
    isAlertsLoading: isAlertsLoading,
    featureFlag: variablesFeatureFlag,
    isClientJourneyLoading: isClientJourneyLoading,
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestRankDescription: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
  }),
  dispatch => ({
    fetchReport: ({reportName, reportParams, appendData}: any) => {
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      return dispatch(fetch({reportName, reportParams, appendData}));
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchReport: ({
      type,
      reportName,
      reportParams: [firstParam = {}, ...restParams] = [],
    }: any) => {
      const featureFlag_CC_SR = get(stateProps, 'featureFlag.CC_SR', false);
      return dispatchProps.fetchReport({
        reportName,
        reportParams: [
          {
            ...firstParam,
            [TYPE]: type,
            [LEVEL]:
              type !== 'candidates'
                ? featureFlag_CC_SR
                  ? 'genZero'
                  : 'frontLine'
                : null,
            [PAGE_SIZE_FIELD_NAME]:
              reportName === REPORT_CLIENT_TO_CONTACT_NEW_CANDIDATE
                ? 1000
                : pageSize,

            [PAGE_NUMBER_FIELD_NAME]: 1,
          },
          ...restParams,
        ],
        appendData: false,
      });
    },
  }),
)(PeopleToContact);
